import React, { SVGProps } from 'react';

const GiftBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={28}
    xmlns="http://www.w3.org/2000/svg"
    color="var(--secondaryBackground)"
    {...props}
    data-palette="GiftBox">
    <path
      d="M23.333 9.333H4.667c-.645 0-1.167.523-1.167 1.167v2.333c0 .645.522 1.167 1.167 1.167h18.666c.645 0 1.167-.522 1.167-1.167V10.5c0-.644-.522-1.167-1.167-1.167ZM14 9.333V24.5"
      stroke="var(--dropdownIconColor)"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.167 14v8.167a2.333 2.333 0 0 1-2.334 2.333H8.168a2.333 2.333 0 0 1-2.333-2.333V14M8.75 9.333a2.917 2.917 0 0 1 0-5.833c1.126-.02 2.229.526 3.165 1.567.937 1.04 1.663 2.527 2.085 4.266.422-1.739 1.149-3.225 2.085-4.266.937-1.04 2.04-1.587 3.165-1.567a2.917 2.917 0 0 1 0 5.833"
      stroke="var(--dropdownIconColor)"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GiftBox;
